import script from "./PopupTool3TableList.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupTool3TableList.vue?vue&type=script&setup=true&lang=js"

import "./PopupTool3TableList.vue?vue&type=style&index=0&id=80255d24&scoped=true&lang=scss"

import exportComponent from "/www/wwwroot/u.xiansuotu.com/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80255d24"]])

export default __exports__